module.exports = __webpack_public_path__ + "static/img/t49.d4bb7c49.png";